import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InvestmentFormFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentFormFields";
import { useCreateInvestmentForm } from "web_myplann/Portfolio/Forms/InvestmentForm/useCreateInvestmentForm";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";

export const CreateInvestmentForm = () => {
	const { t } = useResource();
	const { form, onSubmit, isPending } = useCreateInvestmentForm();

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddShared.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<InvestmentFormFields control={form.control} />
		</PortfolioFormShell>
	);
};
